module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/copy1.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/04_General_information"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("General information")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_General_information#sec1"
    }
  }, [_vm._v("Equipment")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_General_information#sec2"
    }
  }, [_vm._v("Fabrics")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_General_information#sec3"
    }
  }, [_vm._v("Fabric requirements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_General_information#sec4"
    }
  }, [_vm._v("Interfacings and interlinings")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_General_information#sec5"
    }
  }, [_vm._v("Machine sewing thread")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_General_information#sec6"
    }
  }, [_vm._v("Patterns")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_General_information#sec7"
    }
  }, [_vm._v("Transferring markings")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Techniques",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Techniques")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Techniques#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Binding")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Techniques#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blocking and shaping")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Techniques#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gathering")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Techniques#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heirloom sewing")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Techniques#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Piping")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Techniques#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pleating")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Techniques#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pressing")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Techniques#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seams")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Techniques#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Understitching")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Techniques#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Topstitching")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Construction",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Construction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Construction#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assembling the garment")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Construction#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Armholes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Construction#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Button bands")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Construction#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Collars")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Construction#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fasteners")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Constructiona#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hems")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Constructiona#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inserts")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Constructiona#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interfacings")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Constructiona#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Linings")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Constructiona#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Necklines")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Constructiona#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plackets")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Constructiona#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sashes, belts and cummerbunds")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Constructiona#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sleeves")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Constructiona#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your finished garment")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg3-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pg3-2.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0